import { useContext } from 'react';
import { ConstraintsContext } from './Constraints/ConstraintsProvider';

export function useConstraints() {
  return useContext(ConstraintsContext);
}
